/**
 * Theme Module Index
 * 
 * Central export point for all theming functionality.
 * 
 * Usage:
 *   import { applyTheme, ThemeDropdown } from './themes';
 *   
 *   // Apply a theme programmatically
 *   applyTheme('ocean');
 *   applyTheme('forest', true);  // Force dark mode
 *   
 *   // Or use the React components
 *   <ThemeDropdown />        // Compact icon button with dropdown menu (recommended)
 *   <ThemeSwitcher />        // Semantic UI dropdown
 *   <ThemeSwatches />        // Horizontal color swatches
 *   <ThemeCycleButton />     // Single button that cycles through themes
 */

// Core theme management
export {
    applyTheme,
    toggleDarkMode,
    initializeTheme,
    getCurrentTheme,
    isDarkMode,
    getThemeNames,
    getThemeInfo,
    getAllThemes,
    themes
} from './ThemeManager';

// React components
export {
    ThemeDropdown,
    ThemeSwitcher,
    ThemeSwatches,
    ThemeCycleButton,
    Swatch
} from './ThemeSwitcher';

// Default export for backwards compatibility
export { default as ThemeManager } from './ThemeManager';
